module.exports = __webpack_public_path__ + "img/baomufuwu.5a161853.png";